import axios from "axios";

export const baseURL = "https://stage.7saip.com/api/";

const http = axios.create({
  baseURL: baseURL,
});

export default http;
